export { EloMailBlackedIcon } from './mail-blacked-icon'
